import styled from 'styled-components';
import { mixin } from '@wconcept/wconcept-ui-renewal/styles/index';

export const CountdownTimer = styled.div`
  ${mixin.flex({ justify: 'space-between', align: 'center' })};
  width: calc(100% - 40px);
  height: 36px;
  font-weight: 500;
  font-size: 13px;
  line-height: 36px;
  margin: 0 auto;
  padding: 0 16px;
  background: #f9f9f9;

  .countdown {
    flex-shrink: 0;
  }

  &.event-status-2 .countdown,
  &.event-status-3 .countdown {
    color: #ff4600 !important;
  }

  &.event-status-2 .countdown {
    em {
      font-size: 14px;
      margin-right: 4px;
    }
  }

  &.bg-type-black {
    background: #252525;

    .status-text {
      color: #ddd;
    }

    .countdown {
      color: #ddd;
    }
  }

  &.bg-type-opacity {
    background: rgba(172, 172, 172, 0.15);
  }

  @media ${({ theme }) => theme.media.smMax} {
    width: calc(100% - ${mixin.pxToVw('40')});
    height: ${mixin.pxToVw('36')};
    font-size: ${mixin.pxToVw('13')};
    line-height: ${mixin.pxToVw('36')};
    padding: ${mixin.pxToVw('0 16')};

    &.event-status-2 .countdown {
      em {
        font-size: ${mixin.pxToVw('14')};
        margin-right: ${mixin.pxToVw('4')};
      }
    }
  }

  @media ${({ theme }) => theme.media.xl} {
    width: 100%;
    height: 50px;
    font-size: 18px;
    line-height: 50px;
    padding: 0 40px;
    gap: 0 20px;

    &.event-status-2 .countdown {
      em {
        font-weight: 600;
        font-size: 20px;
        margin-right: 10px;
        vertical-align: top;
      }
    }

    &.bg-type-black {
      &.event-status-2 .countdown,
      &.event-status-3 .countdown {
        color: #ff6b33 !important;
      }
    }
  }
`;
